//@ts-expect-error untyped dependency
import Widgets from '../components/customWidgets/constants/widgets';
export const MobileEnabledWidgets = [Widgets.ENGAGEMENT_STREAM, Widgets.DEAL_FORECAST, 'DATA_LAYER'];